module.exports = __webpack_public_path__ + "static/media/socialPiper-post-mobile-en.49fb5fb6.png";